import dynamic from "next/dynamic";
import { AppContextProvider } from "./context/context";
import styles from "./index.module.scss";

const CalculatorContainer = dynamic(
  () =>
    import("./components/calculator/calculatorContainer/calculatorContainer"),
  { ssr: false }
);

export function LgsCalculator() {
  return (
    <AppContextProvider>
      <div className={styles.appContainer}>
        <div className={styles.left}>
          <h1 className={styles.title}>LGS Puan Hesaplama</h1>
          <div className={styles.subTitleContainer}>
            <p className={styles.description}>Muafiyet</p>
            <p className={styles.description}>
              <img src="/images/svg/eyeSlash.svg" alt="eye-slash" />
              Muafiyetinin olduğu dersleri gizleyebilirsin
            </p>
          </div>
          <CalculatorContainer />
        </div>
      </div>
    </AppContextProvider>
  );
}
